import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';
import DownloadApp from 'blocks/DownloadApp/DownloadApp';
import CareerListSection from 'blocks/CareerListSection/CareerListSection';
import { IGenericPage, ICareerPage } from 'types/interfaces';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';

interface ICareers extends IGenericPage, ICareerPage {}

const Careers: NextPage<ICareers> = ({ globalLayoutProps, careers }) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <CareerListSection
        careers={careers}
        countryCodes={globalLayoutProps.countryCodes}
      />
      <DownloadApp />
    </GlobalLayout>
  );
};

export default Careers;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.CAREERS,
  });
  const careerPageProps = await PageService.getCareerPageProps();
  return {
    props: {
      ...genericPageProps,
      ...careerPageProps,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
